import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import CopyArea from './CopyArea';
import css from './CopyAreaWithQRCode.css';
import QRCodeWidget from './QRCodeWidget';

const CopyAreaWithQRCode = ({
    containerStyle = {},
    type = null,
    label = '',
    copyText = '',
    copiedText = '',
    content = '',
    qrCodeLabel = '',
    qrCodeSize = 100,
    logoSrc = '',
    disabled = false,
}) => (
    <div className={classNames(css.container, css[type])} style={containerStyle}>
        <div className={css.copyAreaWithQRCodeContainer}>
            <div className={css.copyAreaContainer}>
                <CopyArea
                    containerStyle={containerStyle}
                    type={type}
                    label={label}
                    copyText={copyText}
                    copiedText={copiedText}
                    content={content}
                    disabled={disabled}
                />
            </div>
            <QRCodeWidget label={qrCodeLabel} size={qrCodeSize} value={content} defaultLogoSrc={logoSrc} disabled={disabled} />
        </div>
    </div>
);

CopyAreaWithQRCode.propTypes = {
    containerStyle: PropTypes.objectOf(PropTypes.any),
    type: PropTypes.oneOf(['small', 'large', null]),
    label: PropTypes.string,
    copyText: PropTypes.string,
    copiedText: PropTypes.string,
    content: PropTypes.string,
    qrCodeLabel: PropTypes.string,
    qrCodeSize: PropTypes.number,
    onCopyClicked: PropTypes.func,
    logoSrc: PropTypes.string,
    disabled: PropTypes.bool,
};

export default CopyAreaWithQRCode;
